import { SET_LEGENDS, SET_LEGENDS_PERMA, SHOW_LEGENDS } from '../actions/legendActions';

const initial_state = {
  list: [],
  show: false
};

export const legendReducer = (state = initial_state, action) => {
  switch (action.type) {
    case SHOW_LEGENDS:
      return {...state, show: action.show};
    case SET_LEGENDS_PERMA: 
      return {...state, list: action.listLegends, show: true};
    case SET_LEGENDS:
      return {...state, list: action.listLegends, show: false};
    default:
      return state;
  }
};